import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { Box } from "@mui/system";
import {
  Button,
  Autocomplete,
  CircularProgress,
  Snackbar,
  Alert,
} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useTheme } from "@mui/material/styles";
import "../Styles/product.css";
import { PhotoCamera } from "@mui/icons-material";
import TextField from "@mui/material/TextField";
import api from "./../Data/api";
import { ADD, UPLOAD, GET } from "../Functions/apiFunction";
import { tokens } from "../theme";

function AddProduct() {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const navigate = useNavigate();

  const [title, settitle] = useState("");
  const [quantity, setquantity] = useState("");
  const [price, setprice] = useState(0);
  const [MRP, setMRP] = useState(0);
  const [tax, settax] = useState();
  const [stock, setstock] = useState(1);
  const [category, setcategory] = useState(null);
  const [categories, setcategories] = useState([]);
  const [subCat, setsubCat] = useState(null);
  const [subCategories, setsubCategories] = useState([]);
  const [offer, setoffer] = useState("");
  const [desc, setdesc] = useState("");
  const [claimer, setclaimer] = useState("");
  const [subs, setsubs] = useState(0);
  const [hasbottle, sethasbottle] = useState(0);
  const [img, setimg] = useState();
  const [LOADING, setLOADING] = useState(false);
  const [snakbarOpen, setsnakbarOpen] = useState(false);
  const [alertType, setalertType] = useState("");
  const [alertMsg, setalertMsg] = useState("");
  const [uploadImage, setuploadImage] = useState();
  const [imgType, setimgType] = useState();
  // Gallery images
  const [galleryImages, setGalleryImages] = useState([]);
  // Time restriction
  const [orderStartTime, setOrderStartTime] = useState("");
  const [orderEndTime, setOrderEndTime] = useState("");
  const [enableTimeRestriction, setEnableTimeRestriction] = useState(false);
  // Pincode restriction
  const [allPincodes, setAllPincodes] = useState([]);
  const [selectedPincodes, setSelectedPincodes] = useState([]);
  const [enablePincodeRestriction, setEnablePincodeRestriction] = useState(false);

  const admin = JSON.parse(sessionStorage.getItem("admin"));
  const token = `Bearer ${admin.token}`;

  const handleSnakBarOpen = () => setsnakbarOpen(true);
  const handleSnakBarClose = () => setsnakbarOpen(false);

  // Fetch categories on component mount
  useEffect(() => {
    fetchCategories();
    fetchAllPincodes();
  }, []);

  // Fetch subcategories when category changes
  useEffect(() => {
    if (category) {
      fetchSubCategories(category.id);
    } else {
      setsubCategories([]);
      setsubCat(null);
    }
  }, [category]);

  const fetchCategories = async () => {
    try {
      const url = `${api}/get_cat`;
      const response = await GET(token, url);
      if (response.response === 200) {
        setcategories(response.data || []);
      }
    } catch (error) {
      console.error("Error fetching categories:", error);
    }
  };

  const fetchSubCategories = async (catId) => {
    try {
      const url = `${api}/get_sub_cat/cat_id/${catId}`;
      const response = await GET(token, url);
      if (response.response === 200) {
        setsubCategories(response.data || []);
      }
    } catch (error) {
      console.error("Error fetching subcategories:", error);
      setsubCategories([]);
    }
  };

  const fetchAllPincodes = async () => {
    try {
      const url = `${api}/get_pincode`;
      const response = await GET(token, url);
      if (response?.data) setAllPincodes(response.data);
    } catch (error) {
      console.error("Error fetching pincodes:", error);
    }
  };

  const addProduct = async (e) => {
    e.preventDefault();
    const data = {
      title: title,
      qty_text: quantity,
      sub_cat_id: subCat?.id,
      price: price,
      tax: tax,
      mrp: MRP,
      offer_text: offer,
      description: desc,
      disclaimer: claimer,
      subscription: subs,
      stock_qty: stock,
      has_bottle: hasbottle,
      ...(enableTimeRestriction && orderStartTime && { order_start_time: orderStartTime }),
      ...(enableTimeRestriction && orderEndTime && { order_end_time: orderEndTime }),
    };

    const url = `${api}/add_product`;
    setLOADING(true);
    const add = await ADD(token, url, data);
    setLOADING(false);
    if (add.response === 200) {
      if (uploadImage) {
        let UploadUrl = `${api}/product/upload_image`;
        const uploadData = {
          image: uploadImage,
          image_type: imgType,
          id: add.id,
        };
        await UPLOAD(token, UploadUrl, uploadData);
      }
      // Upload gallery images
      if (galleryImages.length > 0) {
        let UploadUrl = `${api}/product/upload_image`;
        for (let i = 0; i < galleryImages.length; i++) {
          const uploadData = {
            image: galleryImages[i],
            image_type: 2,
            id: add.id,
          };
          await UPLOAD(token, UploadUrl, uploadData);
        }
      }
      // Save pincode restrictions if enabled
      if (enablePincodeRestriction && selectedPincodes.length > 0) {
        await ADD(token, `${api}/product_pincode/bulk_update`, {
          product_id: add.id,
          pincodes: selectedPincodes.map((p) => p.pin_code),
        });
      }
      handleSnakBarOpen();
      setalertType("success");
      setalertMsg("New Product Added successfully");
      setTimeout(() => {
        navigate("/Products");
      }, 1000);
    } else if (add.response === 201) {
      handleSnakBarOpen();
      setalertType("error");
      setalertMsg(add.message);
    } else {
      handleSnakBarOpen();
      setalertType("error");
      setalertMsg("Something went Wrong! Please Try Again");
    }
  };

  return (
    <>
      <Snackbar
        open={snakbarOpen}
        autoHideDuration={3000}
        onClose={handleSnakBarClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          onClose={handleSnakBarClose}
          severity={alertType}
          sx={{ width: "100%" }}
        >
          {alertMsg}
        </Alert>
      </Snackbar>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          paddingBottom: "10px",
          borderBottom: colors.grey[300],
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <IconButton
            onClick={() => {
              navigate("/Products");
            }}
          >
            <ArrowBackIcon />
          </IconButton>{" "}
          <h2 className="heading"> Add New Product</h2>
        </div>
      </Box>
      <Box component="form" onSubmit={addProduct}>
        <div className="product">
          <div
            className="left"
            style={{
              backgroundColor: colors.cardBG[400],
            }}
          >
            <h2>Product Information</h2>
            <p>
              Enter the required information below . You can change it anytime
              you want.
            </p>
            <TextField
              margin="normal"
              required
              color="secondary"
              fullWidth
              id="Title"
              label="Title"
              name="Title"
              autoComplete="text"
              size="small"
              placeholder="Title"
              onChange={(e) => {
                settitle(e.target.value);
              }}
            />
            <TextField
              margin="normal"
              required
              color="secondary"
              fullWidth
              id="Quantity"
              label="Quantity"
              name="Quantity"
              autoComplete="text"
              size="small"
              onChange={(e) => {
                setquantity(e.target.value);
              }}
            />
            <TextField
              margin="normal"
              required
              fullWidth
              id="Price"
              label="Price"
              name="Price"
              type="number"
              color="secondary"
              autoComplete="number"
              size="small"
              InputProps={{ inputProps: { min: 0 } }}
              onChange={(e) => {
                setprice(e.target.value);
              }}
            />

            <TextField
              margin="normal"
              required
              fullWidth
              id="MRP"
              fullWidthcolor="secondary"
              label="MRP"
              name="MRP"
              type="number"
              InputProps={{ inputProps: { min: 0 } }}
              autoComplete="number"
              size="small"
              onChange={(e) => {
                setMRP(e.target.value);
              }}
            />
            <TextField
              margin="normal"
              color="secondary"
              required
              fullWidth
              id="tax"
              label="Tax( in % )"
              name="tax"
              autoComplete="text"
              size="small"
              value={tax}
              type="number"
              InputProps={{ inputProps: { min: 0, max: 99 } }}
              onChange={(e) => {
                settax(e.target.value);
              }}
            />
            <TextField
              margin="normal"
              required
              fullWidth
              id="Stock"
              color="secondary"
              label="Stock"
              name="Stock"
              type="number"
              InputProps={{ inputProps: { min: 0, max: 10000 } }}
              autoComplete="number"
              size="small"
              onChange={(e) => {
                setstock(e.target.value);
              }}
            />
            <div className="sub">
              <label htmlFor="subscrip" className="subMAin">
                Subscription
              </label>
              <div class="toggle-switch">
                <input
                  class="toggle-input"
                  id="toggle"
                  type="checkbox"
                  onChange={(e) => {
                    setsubs(subs === 0 ? 1 : 0);
                  }}
                />
                <label class="toggle-label" for="toggle"></label>
              </div>
            </div>

            <div className="sub">
              <label htmlFor="hasbottletoggle" className="subMAin">
                Has Glass Bottle
              </label>
              <div class="toggle-switch">
                <input
                  class="toggle-input"
                  id="hasbottletoggle"
                  type="checkbox"
                  onChange={() => {
                    sethasbottle(hasbottle === 0 ? 1 : 0);
                  }}
                />
                <label class="toggle-label" for="hasbottletoggle"></label>
              </div>
            </div>

            <div className="auto">
              <Autocomplete
                disablePortal
                sx={{ width: "45%", marginTop: "40px" }}
                id="category-select"
                color="secondary"
                options={categories}
                value={category}
                onChange={(e, data) => setcategory(data)}
                getOptionLabel={(option) => option?.title || ""}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Category"
                    size="small"
                    fullWidth
                    required
                    color="secondary"
                  />
                )}
              />
              <Autocomplete
                disablePortal
                sx={{ width: "45%", marginTop: "20px" }}
                id="subcategory-select"
                color="secondary"
                options={subCategories}
                value={subCat}
                onChange={(e, data) => setsubCat(data)}
                getOptionLabel={(option) => option?.title || ""}
                disabled={!category}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Sub Category"
                    size="small"
                    fullWidth
                    required
                    color="secondary"
                    helperText={!category ? "Please select a category first" : ""}
                  />
                )}
              />
            </div>
          </div>
          <div
            className="right"
            style={{
              backgroundColor: colors.cardBG[400],
            }}
          >
            <div className="image">
              <label htmlFor="productImage" className="lbl">
                Thumbnail Image (1:1)
              </label>
              <p style={{ fontSize: "12px", color: "#718096", marginBottom: "8px" }}>
                This image shows in product lists. Use a square (1:1) image.
              </p>
              <div className="imgDiv">
                <img
                  src={
                    img
                      ? img
                      : "https://icons-for-free.com/iconfiles/png/512/mountains+photo+photos+placeholder+sun+icon-1320165661388177228.png"
                  }
                  alt="img"
                />
                <div className="upload">
                  {" "}
                  <Button
                    fullWidth
                    color="secondary"
                    aria-label="upload picture"
                    component="label"
                    variant="contained"
                  >
                    <input
                      hidden
                      accept=".png, .jpg, .jpeg"
                      type="file"
                      onChange={(e) => {
                        if (e.target.files[0].size / 1024 >= 2048) {
                          alert("file size must be less then 2mb");
                        }
                        if (
                          e.target.files &&
                          e.target.files[0] &&
                          e.target.files[0].size / 1024 <= 2048
                        ) {
                          setimg(URL.createObjectURL(e.target.files[0]));
                          setuploadImage(e.target.files[0]);
                          setimgType(1);
                        }
                      }}
                    />
                    Select Thumbnail <PhotoCamera />
                  </Button>
                </div>
              </div>

              {/* Gallery Images */}
              <label className="lbl" style={{ marginTop: "24px", display: "block" }}>
                Gallery Images (Detail Page)
              </label>
              <p style={{ fontSize: "12px", color: "#718096", marginBottom: "8px" }}>
                These images show in the product detail carousel. Max 5 images, 2MB each.
              </p>
              <div style={{ display: "flex", flexWrap: "wrap", gap: "10px", marginTop: "8px" }}>
                {galleryImages.map((file, idx) => (
                  <div key={idx} style={{ position: "relative", width: "80px", height: "80px" }}>
                    <img
                      src={URL.createObjectURL(file)}
                      alt={`gallery-${idx}`}
                      style={{ width: "80px", height: "80px", objectFit: "cover", borderRadius: "8px", border: "1px solid #e2e8f0" }}
                    />
                    <button
                      type="button"
                      onClick={() => {
                        setGalleryImages(galleryImages.filter((_, i) => i !== idx));
                      }}
                      style={{
                        position: "absolute", top: "-6px", right: "-6px",
                        width: "20px", height: "20px", borderRadius: "50%",
                        background: "#d32f2f", color: "#fff", border: "none",
                        fontSize: "12px", cursor: "pointer", lineHeight: "20px",
                        textAlign: "center"
                      }}
                    >×</button>
                  </div>
                ))}
                {galleryImages.length < 5 && (
                  <Button
                    component="label"
                    variant="outlined"
                    color="secondary"
                    sx={{ width: "80px", height: "80px", minWidth: "80px", borderStyle: "dashed" }}
                  >
                    <input
                      hidden
                      accept=".png, .jpg, .jpeg"
                      type="file"
                      onChange={(e) => {
                        if (e.target.files && e.target.files[0]) {
                          if (e.target.files[0].size / 1024 >= 2048) {
                            alert("file size must be less than 2mb");
                            return;
                          }
                          setGalleryImages([...galleryImages, e.target.files[0]]);
                        }
                      }}
                    />
                    +
                  </Button>
                )}
              </div>
              <p style={{ fontSize: "11px", color: "#a0aec0", marginTop: "6px" }}>
                {galleryImages.length}/5 images added
              </p>
            </div>
          </div>
        </div>
        <div
          className="desc"
          style={{
            backgroundColor: colors.cardBG[400],
          }}
        >
          <h2>Other Information</h2>

          <TextField
            margin="normal"
            fullWidth
            id="Offer"
            label="Offer"
            name="Offer"
            autoComplete="text"
            color="secondary"
            size="small"
            onChange={(e) => {
              setoffer(e.target.value);
            }}
          />
          <TextField
            margin="normal"
            fullWidth
            id="Description"
            color="secondary"
            label="Description"
            name="Description"
            autoComplete="text"
            size="small"
            multiline
            onChange={(e) => {
              setdesc(e.target.value);
            }}
          />
          <TextField
            margin="normal"
            fullWidth
            id="Disclaimer"
            label="Disclaimer"
            color="secondary"
            name="Disclaimer"
            autoComplete="text"
            size="small"
            minRows="3"
            multiline
            onChange={(e) => {
              setclaimer(e.target.value);
            }}
          />
        </div>

        {/* Order Time Restriction */}
        <div className="desc" style={{ backgroundColor: colors.cardBG[400] }}>
          <h2>⏰ Order Time Restriction</h2>
          <p>Set a time window during which customers can place orders for this product.</p>
          <div className="sub" style={{ marginBottom: "12px" }}>
            <label className="subMAin">Enable Time Restriction</label>
            <div className="toggle-switch">
              <input
                className="toggle-input"
                id="toggleTime"
                type="checkbox"
                checked={enableTimeRestriction}
                onChange={(e) => setEnableTimeRestriction(e.target.checked)}
              />
              <label className="toggle-label" htmlFor="toggleTime"></label>
            </div>
          </div>
          {enableTimeRestriction && (
            <div style={{ display: "flex", gap: "16px", marginTop: "8px" }}>
              <TextField
                label="Order Start Time"
                type="time"
                size="small"
                color="secondary"
                value={orderStartTime}
                onChange={(e) => setOrderStartTime(e.target.value)}
                InputLabelProps={{ shrink: true }}
                helperText="Orders allowed FROM this time"
                sx={{ flex: 1 }}
              />
              <TextField
                label="Order End Time"
                type="time"
                size="small"
                color="secondary"
                value={orderEndTime}
                onChange={(e) => setOrderEndTime(e.target.value)}
                InputLabelProps={{ shrink: true }}
                helperText="Orders allowed UNTIL this time"
                sx={{ flex: 1 }}
              />
            </div>
          )}
        </div>

        {/* Pincode Restriction */}
        <div className="desc" style={{ backgroundColor: colors.cardBG[400] }}>
          <h2>📍 Pincode Restriction</h2>
          <p>Restrict this product to specific delivery pincodes. If none selected, product is available everywhere.</p>
          <div className="sub" style={{ marginBottom: "12px" }}>
            <label className="subMAin">Enable Pincode Restriction</label>
            <div className="toggle-switch">
              <input
                className="toggle-input"
                id="togglePin"
                type="checkbox"
                checked={enablePincodeRestriction}
                onChange={(e) => setEnablePincodeRestriction(e.target.checked)}
              />
              <label className="toggle-label" htmlFor="togglePin"></label>
            </div>
          </div>
          {enablePincodeRestriction && (
            <div>
              <Autocomplete
                multiple
                options={allPincodes}
                getOptionLabel={(option) => option.pin_code?.toString() || ""}
                value={selectedPincodes}
                onChange={(e, val) => setSelectedPincodes(val)}
                size="small"
                color="secondary"
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Select Allowed Pincodes"
                    color="secondary"
                    helperText={`${selectedPincodes.length} pincode(s) selected`}
                  />
                )}
              />
            </div>
          )}
        </div>

        <div className="delete">
          <Button
            fullWidth
            type="submit"
            variant="contained"
            color="secondary"
            sx={{ fontWeight: "600", letterSpacing: "1px" }}
          >
            {LOADING ? <CircularProgress size={20} /> : "Add New Product"}
          </Button>
        </div>
      </Box>
    </>
  );
}

export default AddProduct;
